import Lang from 'assets/Lang';
import ModalLoading from 'common/components/modals/ModalLoading';
import DropAlert from 'common/components/views/DropAlert';
import Fetch from 'common/helpers/Fetch';
import ApiHost from 'common/helpers/ApiHost';
import Funcs from 'common/helpers/Funcs';
import Time from 'common/helpers/Time';
import md5 from 'common/libs/Md5';
import AdmobService from 'common/services/AdmobService';
import NavigationService from 'common/services/NavigationService';
import PushNotificationService from 'common/services/PushNotificationService';
import StorageService from 'common/services/StorageService';
import TrackingService from 'common/services/TrackingService';
import ApiConst from 'consts/ApiConst';
import AppConst from 'consts/AppConst';
import DataConst from 'consts/DataConst';
import ScreenConst from 'consts/ScreenConst';
import StorageConst from 'consts/StorageConst';
import UIConst from 'consts/UIConst';
import UrlConst from 'consts/UrlConst';
import { cloneDeep, pick } from 'lodash';
import moment from 'moment';
import * as Keychain from 'react-native-keychain';
import uuid from 'react-native-uuid';
import Realms from 'realm/Realms';
import CategoryController from 'realm/controllers/CategoryController';
import CustomerController from 'realm/controllers/CustomerController';
import ImportOrderController from 'realm/controllers/ImportOrderController';
import OrderController from 'realm/controllers/OrderController';
import OrderItemController from 'realm/controllers/OrderItemController';
import ProductController from 'realm/controllers/ProductController';
import ProviderController from 'realm/controllers/ProviderController';
import SettingController from 'realm/controllers/SettingController';
import UnitController from 'realm/controllers/UnitController';
import CustomerModel from 'realm/models/CustomerModel';
import ProductModel from 'realm/models/ProductModel';
import AppAction from 'states/context/actions/AppAction';
import HomeActionCreator from 'states/redux/actionCreators/HomeActionCreator';
import Const from '../consts/Const';
import Configs from './Configs';
import File from 'common/helpers/File';

const proKeys = ['974ce5e8b4c8d5803ebdf24cb83090bd', md5('disableadsqlbh')];
const proEmails = ['kaseruko@gmail.com', 'hoainhu181096@gmail.com'];

// Settings mặc định, reset lại khi logout để không dính setting của tk trước
const defaultSettings = cloneDeep(pick(Configs, ['staffSettings', 'pointSettings', 'productSettings', 'orderSettings', 'billSettings', 'eInvoiceSettings', 'prefix']));

const defaultData = {
  filtered: () => {},
  sorted: () => {},
  map: () => {},
  length: 0
};

const Utils = {
  hasOfflineData: false,
  applyStaffSession: () => {
    const user = Configs.user || {};
    user.isStaff = !!user?.shopInfo;
    Configs.user = user;
    Configs.staff = user.isStaff ? user : null;
    Configs.isManagerApp = !user.isStaff || user?.role === 'manager';
  },
  static: {
    products: [],
    customers: [],
    categories: [],
    units: []
  },
  products: [],
  categories: [],
  units: [],
  customers: [],
  data: {
    orders: defaultData,
    products: defaultData,
    provider: defaultData,
    importOrders: defaultData,
    customers: defaultData,
    categories: defaultData,
    units: defaultData
  },
  appConfigsPromise: null,

  loadAppConfigs: () => {
    Utils.appConfigsPromise = (async () => {
      try {
        const configs = await Fetch.get(ApiConst.HOME.GET_CONFIGS, {}, { disableAlert: true });
        if (configs.status !== 200) return;

        Configs.appConfigs = configs.data?.reduce((appConfigs, item) => ({ ...appConfigs, [item.key]: item.value }), Configs.appConfigs) || Configs.appConfigs;
        Configs.isPrepareVersion = AppConst.IS_IOS && Funcs.compareVersion(AppConst.VERSION, Configs.appConfigs?.version) > 0;
      } catch (err) {
        Funcs.log('ERROR', err);
      }
    })();
    return Utils.appConfigsPromise;
  },

  waitForAppConfigs: async () => {
    if (!Utils.appConfigsPromise) return Utils.loadAppConfigs();
    return Utils.appConfigsPromise;
  },

  init: async () => {
    // Storage
    try {
      // if (__DEV__) {
      //   const userToken =
      //     // 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2NjUyMDM3OTMsImlkIjoiMjgiLCJpYXQiOjE2NjI2MTE3OTN9.iYfn03xQ8Sq8d5XCRO0dlPFU_92SMr9M_-pzAoAnxP8'; // Huynh tu nhu. 28
      //     'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJleHAiOjE2NjUzMDE3MzQsImlkIjo1OCwiaWF0IjoxNjYyNzA5NzM0fQ.ILQeokc0V-oHJR_Pn5_SrkZvtn7IrC-8O1RRe5rywAE'; // nhu. 71
      //   await StorageService.save(StorageConst.TOKEN, userToken);
      // }
      Funcs.log('Utils init');
      Utils.static.products = [];
      Utils.static.customers = [];
      Utils.static.categories = [];
      Utils.static.units = [];
      const token = await StorageService.get(StorageConst.TOKEN);
      Configs.token = token;
      Configs.online = !!Configs.token;

      // Server
      await ApiHost.load();
      Fetch.init();

      // Get configs
      Utils.loadAppConfigs();

      // Check lại country code từ IP
      try {
        let countryCode = await StorageService.get(StorageConst.COUNTRY_CODE);
        if (!countryCode) {
          const countryData = await Fetch.get('http://ip-api.com/json', {}, { disableAlert: true });
          countryCode = countryData?.data?.countryCode;
          StorageService.save(StorageConst.COUNTRY_CODE, countryCode);
        }
        if (countryCode?.toLowerCase() !== Configs.countryCode?.toLowerCase()) {
          Configs.countryCode = countryCode;
          Configs.init();
        }
      } catch (err) {
        Funcs.log('ERROR', err);
      }

      // Check printer ở dữ liệu local, ko dùng online nữa
      const printer = await StorageService.get(StorageConst.BILL_PRINTER_SETTING);
      if (printer) Configs.printer = { ...Configs.printer, ...printer };
      const printerAddress = await StorageService.get(StorageConst.PRINTER_ADDRESS);
      Configs.printer.address = printerAddress || '';
      const spacingBottom = await StorageService.get(StorageConst.PRINTER_SPACING_BOTTOM);
      Configs.printer.spacingBottom = !isNaN(spacingBottom) ? spacingBottom : 3;
      const printerName = await StorageService.get(StorageConst.PRINTER_NAME);
      Configs.printer.name = printerName || '';
      const printerType = await StorageService.get(StorageConst.PRINTER_TYPE);
      Configs.printer.type = printerType || 0;
      const printerMethod = await StorageService.get(StorageConst.PRINTER_METHOD);
      Configs.printer.method = printerMethod != null ? parseInt(printerMethod) : 0;
      const printerSize = await StorageService.get(StorageConst.PRINTER_SIZE);
      Configs.printer.size = printerSize || 80;
      const printerThreshold = await StorageService.get(StorageConst.PRINTER_THRESHOLD);
      Configs.printer.threshold = printerThreshold || 160;
      const printerSpeed = await StorageService.get(StorageConst.PRINTER_SPEED);
      Configs.printer.speed = printerSpeed || 0;
      const printerDisplayName = await StorageService.get(StorageConst.PRINTER_DISPLAY_NAME);
      Configs.printer.displayName = printerDisplayName || '';
      let printBarcodeSettings = await StorageService.get(StorageConst.PRINT_BARCODE_SETTING);
      if (printBarcodeSettings) {
        printBarcodeSettings = Funcs.jsonParse(printBarcodeSettings);
        Configs.printBarcodeSettings = { ...Configs.printBarcodeSettings, ...printBarcodeSettings };
      }
      const orderSettings = await StorageService.get(StorageConst.ORDER_SETTING);
      if (orderSettings) Configs.orderSettings = { ...Configs.orderSettings, ...orderSettings };
      const billSettings = await StorageService.get(StorageConst.BILL_SETTING);
      if (billSettings) Configs.billSettings = { ...Configs.billSettings, ...billSettings };

      // New printers
      const billPrinterObj = await StorageService.get(StorageConst.BILL_PRINTER);
      if (billPrinterObj && billPrinterObj.address) {
        Configs.billPrinter = { ...Configs.billPrinter, ...billPrinterObj };
        Configs.printer = { ...Configs.printer, ...billPrinterObj };
      }
      const labelPrinterObj = await StorageService.get(StorageConst.LABEL_PRINTER);
      if (labelPrinterObj && labelPrinterObj.address) {
        Configs.labelPrinter = { ...Configs.labelPrinter, ...labelPrinterObj };
        Configs.printBarcodeSettings = { ...Configs.printBarcodeSettings, ...labelPrinterObj };
      }

      const draftOrders = await StorageService.get(StorageConst.DRAFT_ORDERS);
      if (draftOrders) HomeActionCreator.updateDraftOrders(draftOrders);
      Funcs.log('Draft orders', draftOrders);

      // Ads event count
      const eventCount = await StorageService.get(StorageConst.ADS_EVENT_COUNT);
      AdmobService.eventCount = eventCount || 0;

      // Local data
      Utils.customers = (await StorageService.get(StorageConst.LIST_CUSTOMERS)) || [];
      Utils.categories = (await StorageService.get(StorageConst.LIST_CATEGORIES)) || [];
      Utils.products = (await StorageService.get(StorageConst.LIST_PRODUCTS)) || [];
      if (!Array.isArray(Utils.customers)) Utils.customers = [];
      if (!Array.isArray(Utils.categories)) Utils.categories = [];
      if (!Array.isArray(Utils.products)) Utils.products = [];
      const { products, customers, categories } = Utils;
      Funcs.log('Local data', { products, customers, categories });

      Utils.categories = (await StorageService.get(StorageConst.LIST_CATEGORIES)) || [];

      // Online
      if (Configs.online) {
        Funcs.log('ONLINE MODE');
        const res = await Fetch.post(ApiConst.AUTHENTICATE.REFRESH, {}, { forceFailover: true });
        if (res.status === 200) {
          Configs.user = res.data;
          await Utils.initOnlineData();
          if (res.data.token) StorageService.save(StorageConst.TOKEN, res.data.token);
          Configs.startScreen = ScreenConst.APP_NAVIGATOR;
        } else {
          Configs.user = {};
          Configs.startScreen = ScreenConst.AUTH_NAVIGATOR;
        }
      } else {
        Funcs.log('OFFLINE MODE');
        Configs.user = {};
        await Realms.init();
        // if (__DEV__) await Utils.intSampleData();

        // Ads check
        var feedback = await StorageService.get(StorageConst.FEEDBACK);
        if (feedback) {
          const millSecondOf5Day = 2 * 24 * 60 * 60 * 1000;
          Configs.isFreeVersion = !(proKeys.indexOf(feedback) >= 0 || feedback >= Date.now() - millSecondOf5Day);
        }

        // Nếu user miễn phí + Hiển thị quảng cáo luôn cho bản offline
        if (Configs.isFreeVersion) Configs.adsEnable = true;

        // User data
        let userData = await StorageService.get('USER_INFO');
        StorageService.user = userData;

        // Realm
        // ['PREFIX_ORDER', 'PREFIX_CUSTOMER', 'PREFIX_PRODUCT', 'PREFIX_CATEGORY', 'PREFIX_CURRENCY']);
        let settings = await SettingController.getAll();
        Configs.settings.showOrderStatus = true;
        for (var i = 0; i < settings.length; i += 1) {
          let item = settings[i];
          if (item.key === 'LANGUAGE') Configs.language = item.value;
          if (item.key === DataConst.FONT_SIZE_TYPE) {
            Configs.settings.fontSizeType = Funcs.jsonParse(item.value || 0);
            UIConst.changeFontSize();
          }
          Lang.change();
          if (item.key === 'PREFIX_ORDER') Configs.prefix.order = item.value;
          if (item.key === 'PREFIX_CUSTOMER') Configs.prefix.customer = item.value;
          if (item.key === 'PREFIX_PRODUCT') Configs.prefix.product = item.value;
          if (item.key === 'PREFIX_CATEGORY') Configs.prefix.category = item.value;
          if (item.key === 'SHOP_NAME') Configs.user.name = item.value;
          if (item.key === 'SHOP_EMAIL') Configs.user.email = item.value;
          if (item.key === 'SHOP_ADDRESS') Configs.user.address = item.value;
          if (item.key === 'SHOP_PHONE') Configs.user.phone = item.value;
          if (item.key === 'SHOP_BANK') Configs.user.bank = item.value;
          if (item.key === 'SHOP_INFO') Configs.user.billInfo = item.value;
          if (item.key === 'SHOP_AVATAR') Configs.user.avatar = item.value;
          if (item.key === 'PREFIX_CURRENCY') Configs.currency = item.value;
          if (item.key === DataConst.TIME_FORMAT) Configs.timeFormat = item.value;
          if (item.key === StorageConst.PRINTER_ADDRESS) Configs.printer.address = item.value || '';
          if (item.key === StorageConst.PRINTER_NAME) Configs.printer.name = item.value || '';
          if (item.key === DataConst.INVOICE_THANK) Configs.invoiceThank = item.value || '';
          if (item.key === DataConst.INVOICE_SURCHAGE) Configs.invoiceSurchage = item.value || Lang.order.surcharge;
          if (item.key === DataConst.PRINT_COUNT) Configs.printCount = Funcs.jsonParse(item.value || 0);
          if (item.key === DataConst.SHOW_GRID) Configs.settings.showGrid = Funcs.jsonParse(item.value || 'false');
          if (item.key === DataConst.SHOW_DEBT) Configs.settings.showDebt = Funcs.jsonParse(item.value || 'false');
          if (item.key === DataConst.SHOW_WARNING_OUT_STOCK) Configs.settings.showWarningOutStock = Funcs.jsonParse(item.value || 'false');
          if (item.key === DataConst.DISCOUNT_TYPE) Configs.settings.discountType = Funcs.jsonParse(item.value || 0);
          if (item.key === DataConst.SHOW_DISCOUNT) Configs.settings.showDiscount = Funcs.jsonParse(item.value || 0);
          if (item.key === DataConst.SHOW_REVENUE) Configs.settings.showRevenue = Funcs.jsonParse(item.value || 0);
          if (item.key === 'ODD_NUMBER') Configs.settings.showOdd = Funcs.jsonParse(item.value || 'true');
          if (item.key === DataConst.SHOW_ORDER_STATUS) Configs.settings.showOrderStatus = Funcs.jsonParse(item.value || 'true');
          if (item.key === DataConst.SHOW_HOME_CHART) Configs.settings.showHomeChart = Funcs.jsonParse(item.value || 'false');
          if (item.key === DataConst.SHOW_HOME_REVENUE) Configs.settings.showHomeRevenue = Funcs.jsonParse(item.value || 'false');
          if (item.key === DataConst.SHOW_HOME_FINANCIAL) Configs.settings.showHomeFinancial = Funcs.jsonParse(item.value || 'false');
          if (item.key === DataConst.SHOW_HOME_STATISTIAL) Configs.settings.showHomeStatistial = Funcs.jsonParse(item.value || 'false');
          if (item.key === DataConst.SHOW_ORDER_CUSTOMER) Configs.settings.showOrderCustomer = Funcs.jsonParse(item.value || 'false');
          if (!Configs.user.billInfo) {
            Configs.user.billInfo = `${Configs.user.phone ? `${Lang.profile.numberPhone}: ${Configs.user.phone}` : Lang.profile.numberPhone}\n${Configs.user.address ||
              Lang.profile.address}\n${Configs.user.bank || Lang.profile.bank}`;
          }
          Configs.dateTimeFormat = `HH:mm ${Configs.timeFormat}`;
        }

        // Data
        Utils.data.orders = await OrderController.getAll();
        Utils.data.products = await ProductController.getAll();
        Utils.data.provider = await ProviderController.getAll();
        Utils.data.customers = await CustomerController.getAll();
        Utils.data.categories = await CategoryController.getAll();
        Utils.data.importOrders = await ImportOrderController.getAll();
        Utils.data.units = await UnitController.getAll();

        // Handle has data
        const hasOfflineData =
          Utils.data.orders?.length > 0 ||
          Utils.data.products?.length > 0 ||
          Utils.data.provider?.length > 0 ||
          Utils.data.customers?.length > 0 ||
          Utils.data.importOrders?.length > 0 ||
          Utils.data.categories?.length > 0;
        StorageService.save(StorageConst.HAS_OFFLINE_DATA, hasOfflineData);
        Utils.hasOfflineData = hasOfflineData;
        const usingOffline = await StorageService.get(StorageConst.USING_OFFLINE);
        if (hasOfflineData || usingOffline) Configs.startScreen = ScreenConst.APP_NAVIGATOR;
      }

      // Disable ads
      if (proEmails.indexOf(Configs.user?.email) >= 0 && !__DEV__) Configs.isFreeVersion = false;
      Utils.applyStaffSession();
      AppAction.updateUserData(Configs.user);
      Funcs.log('FreeVersion', Configs.isFreeVersion, 'adsEnable', Configs.adsEnable, 'startScreen', Configs.startScreen, 'hasOfflineData', Utils.hasOfflineData);
    } catch (err) {
      Funcs.log(err);
    }
  },

  initOnlineData: async () => {
    // Static
    Configs.online = true;
    Utils.static.products = [];
    Utils.static.customers = [];
    // Utils.static.categories = [];
    Utils.static.units = [];

    // Local storage
    try {
      Configs.warehouse = (await StorageService.get(StorageConst.CURRENT_WAREHOUSE)) || { id: 0, name: Lang.warehouse.default };
      const localSettings = await StorageService.get(StorageConst.LOCAL_SETTING);
      if (localSettings) Configs.localSettings = { ...Configs.localSettings, ...localSettings };
    } catch (err) {
      console.log('ERROR', err);
    }

    // Setting
    let { prefix, printCount, language, currency, settings, staffSettings, pointSettings, productSettings, invoiceThank, token, expired } = Configs.user;
    let { orderSettings, billSettings, eInvoiceSettings } = Configs.user;
    if (settings) {
      settings = Funcs.jsonParse(settings);
      delete settings.fontSizeType; // Xoá setting font từ server, dùng font từ local
      Configs.settings = { ...Configs.settings, ...settings };
      if (Configs.settings.timeFormat) Configs.timeFormat = Configs.settings.timeFormat;
      Configs.dateTimeFormat = `HH:mm ${Configs.timeFormat}`;
    }
    if (staffSettings) {
      staffSettings = Funcs.jsonParse(staffSettings);
      Configs.staffSettings = { ...Configs.staffSettings, ...staffSettings };
    }
    if (pointSettings) {
      pointSettings = Funcs.jsonParse(pointSettings);
      Configs.pointSettings = { ...Configs.pointSettings, ...pointSettings };
    }
    if (productSettings) {
      productSettings = Funcs.jsonParse(productSettings);
      Configs.productSettings = { ...Configs.productSettings, ...productSettings };
    }
    if (orderSettings) {
      orderSettings = Funcs.jsonParse(orderSettings);
      Configs.orderSettings = { ...Configs.orderSettings, ...orderSettings };
    }
    if (Configs.user?.shopInfo) {
      const staffOrderStatus = await StorageService.get(StorageConst.STAFF_ORDER_STATUS);
      if (staffOrderStatus != null) Configs.orderSettings.lastStatus = staffOrderStatus;
    }
    if (billSettings) {
      billSettings = Funcs.jsonParse(billSettings);
      Configs.billSettings = { ...Configs.billSettings, ...billSettings };
    }
    if (eInvoiceSettings) {
      eInvoiceSettings = Funcs.jsonParse(eInvoiceSettings);
      Configs.eInvoiceSettings = { ...Configs.eInvoiceSettings, ...eInvoiceSettings };
    }
    if (!Configs.user.billInfo) {
      Configs.user.billInfo = '';
      if (Configs.user.phone) Configs.user.billInfo += `${Lang.profile.numberPhone}: ${Configs.user.phone}\n`;
      if (Configs.user.address) Configs.user.billInfo += `${Lang.profile.address}: ${Configs.user.address}\n`;
      if (Configs.user.bank) Configs.user.billInfo += `${Lang.profile.bank}: ${Configs.user.bank}\n`;
    }
    if (Configs.user?.permission) Configs.user.permission = Funcs.jsonParse(Configs.user.permission);

    // Prefix
    if (prefix) {
      prefix = Funcs.jsonParse(prefix);
      Configs.prefix = { ...Configs.prefix, ...prefix };
    }

    // Profile
    if (language) Configs.language = language;
    Lang.change();
    Configs.currency = currency || '';

    // Warehouse
    if (!Configs.user?.warehouses) Configs.user.warehouses = [];
    Configs.user?.warehouses.unshift({ id: 0, name: Lang.warehouse.default, address: Configs.user?.address, phone: Configs.user?.phone, email: Configs.user?.email, note: '' });
    const find = Configs.user?.warehouses?.find((e) => e.id === Configs.warehouse?.id);
    if (!find) Configs.warehouse = { id: 0 };

    const warehouseIds = Configs.user?.warehouseIds;
    if (Configs.user?.isStaff && Array.isArray(warehouseIds) && warehouseIds.length === 0) {
      DropAlert.error('', Lang.onlyManagerSupport);
      await Utils.logout();
      return;
    }
    if (Array.isArray(warehouseIds) && warehouseIds.length > 0) {
      const currentInList = warehouseIds.includes(Configs.warehouse?.id);
      if (!currentInList) {
        const first = Configs.user?.warehouses?.find((e) => e.id === warehouseIds[0]);
        if (first) {
          Configs.warehouse = first;
          StorageService.save(StorageConst.CURRENT_WAREHOUSE, first);
        }
      }
    }

    AppAction.changeWarehouse(Configs.warehouse);

    // Profile
    if (printCount) Configs.printCount = printCount;
    if (invoiceThank) Configs.invoiceThank = invoiceThank;
    Configs.invoiceSurchage = Configs.settings?.invoiceSurchage || Lang.order.surcharge;
    Configs.hasOfflineData = await StorageService.get(StorageConst.HAS_OFFLINE_DATA);
    Configs.token = Configs.token || token;
    Configs.online = !!Configs.token;

    // Cho sử dụng quá 2 ngày nếu hết hạn
    const millSecondOf5Day = 2 * 24 * 60 * 60 * 1000;
    const expiredMillisecond = expired ? Time.toMillisecond(expired) : 0;
    Configs.isFreeVersion = expiredMillisecond < Date.now() - millSecondOf5Day;

    // Nếu user miễn phí + tạo hơn 2 tuần mới bắt đầu hiển thị quảng cáo
    Configs.adsEnable = false;
    if (Configs.isFreeVersion && moment(Configs.user?.createdAt).valueOf() < Date.now() - 2 * 7 * 24 * 60 * 60 * 1000) {
      Configs.adsEnable = true;
    }
  },

  saveLocalData: async (force = false, type = 'all') => {
    try {
      if (!Configs.user?.id) return;
      let hasLocalData = await StorageService.get(StorageConst.HAS_LOCAL_DATA);
      if (!force && hasLocalData) return;
      let saveSuccess = true;
      if (type === 'all' || type === 'product') {
        let products = await Fetch.get(ApiConst.PRODUCT.GET_V3, {}, { disableAlert: true });
        if (products.status === 200) {
          products = products.data;
          Utils.products = products;
          StorageService.save(StorageConst.LIST_PRODUCTS, products);
        } else {
          saveSuccess = false;
        }
        const categories = await Fetch.get(ApiConst.CATEGORY.GET, {}, true);
        if (categories.status === 200) {
          Utils.categories = categories.data;
          StorageService.save(StorageConst.LIST_CATEGORIES, Utils.categories);
        } else {
          saveSuccess = false;
        }
      }
      if (type === 'all' || type === 'customer') {
        let customers = await Fetch.get(ApiConst.CUSTOMER.GET, {}, { disableAlert: true });
        if (customers.status === 200) {
          customers = customers.data;
          Utils.customers = customers;
          StorageService.save(StorageConst.LIST_CUSTOMERS, customers);
        } else {
          saveSuccess = false;
        }
      }
      StorageService.save(StorageConst.HAS_LOCAL_DATA, saveSuccess);
      if (hasLocalData) Funcs.log('Draft data', { customers: Utils.customers, products: Utils.products });
    } catch (err) {
      console.log('ERROR', err);
    }
  },

  intSampleData: async () => {
    if (Configs.online) return;
    const maxData = 100;
    const categories = await CategoryController.getAll();
    if (categories.length < 2) {
      Funcs.log('==> Create category');
      for (let i = 0; i < 100; i += 1) {
        await CategoryController.add({ id: i + 1, name: 'Category ' + (i + 1), createdAt: new Date() });
      }
    }

    const products = await ProductController.getAll();
    if (products.length < maxData) {
      Funcs.log('==> Create products');
      for (let i = 0; i < maxData; i += 1) {
        const buyPrice = Funcs.random(1000, 2000);
        await ProductController.add({
          id: i + 1,
          name: 'Product ' + (i + 1),
          quantity: Funcs.random(0, 10),
          sellPrice: buyPrice + Funcs.random(1000, 2000),
          buyPrice,
          category: await CategoryController.getById(Funcs.random(1, 100)),
          createdAt: new Date()
        });
      }
    }

    const customers = await CustomerController.getAll();
    if (customers.length < maxData) {
      Funcs.log('==> Create customers');
      for (let i = 0; i < maxData; i += 1) {
        await CustomerController.add({ id: i + 1, name: 'Customer ' + (i + 1), createdAt: new Date() });
      }
    }

    const orders = await OrderController.getAll();
    if (orders.length < maxData) {
      Funcs.log('==> Create orders');
      for (let i = 0; i < maxData; i += 1) {
        const customer = await CustomerController.getById(Funcs.random(1, maxData));
        const order = await OrderController.add({
          id: await OrderController.genNewId(),
          customer,
          money: 0,
          paid: 0,
          status: Funcs.random(0, 2),
          createdAt: moment(new Date())
            .subtract(Funcs.random(0, 10), 'days')
            .toDate()
        });

        let orderItems = [];
        let realTotalMoney = 0;
        for (let k = 0; k < 5; k += 1) {
          const amount = Funcs.random(1, 5);
          const product = await ProductController.getById(Funcs.random(1, maxData));
          const discount = Funcs.random(0, 10);
          let orderItem = await OrderItemController.add({
            id: await OrderItemController.genNewId(),
            product,
            amount,
            discount,
            price: product.sellPrice - (product.sellPrice * discount) / 100,
            buyPrice: product.buyPrice,
            order
          });
          realTotalMoney += amount * (product.sellPrice - (discount / 100) * product.sellPrice);
          orderItems.push(orderItem);
        }
        Realms.write(async () => {
          customer.orders.push(order);
          order.orderItems = orderItems;
          order.money = realTotalMoney;
          order.paid = realTotalMoney;
        });
      }
    }
    Funcs.log('==> Init sample data finish');
  },

  printInvoice: async (orderDetail) => {
    // Check printer
    Funcs.log('Printer order', orderDetail);
    if (!Configs.printer?.address) {
      DropAlert.error('', Lang.printer.notConnect);
      return;
    }
  },

  getImagePath(userId) {
    if (!userId || userId < 0) userId = Configs.user.isStaff ? Configs.user?.userId : Configs.user?.id;
    return Configs.online || Configs.draftMode ? UrlConst.IMAGES + userId + '/' : Const.imagePath;
  },

  async getCustomerList(isProvider) {
    if (Configs.draftMode) {
      if (Utils.static.customers?.length < 1) Utils.static.customers = await StorageService.get(StorageConst.LIST_CUSTOMERS);
      return Utils.static.customers;
    }
    if (Configs.online) return [];
    if (!isProvider && Utils.static.customers?.length > 0) return Utils.static.customers;
    let customerList = [];
    customerList = isProvider ? Utils.data.provider : Utils.data.customers;
    customerList = customerList.sorted('id', true);
    customerList = Realms.convertToObjects(customerList, CustomerModel);
    if (!isProvider) Utils.static.customers = customerList;
    return customerList;
  },

  async getProductList() {
    if (Configs.draftMode) {
      if (Utils.static.products?.length < 1) Utils.static.products = await StorageService.get(StorageConst.LIST_PRODUCTS);
      return Utils.static.products;
    }
    if (Configs.online) return [];
    if (Utils.static.products?.length > 0) return Utils.static.products;
    let products = [];
    Utils.data.products = await ProductController.getAll();
    products = Utils.data.products;
    products = products.sorted('id', true);
    products = Realms.convertToObjects(products, ProductModel);
    Utils.static.products = products;
    return products;
  },

  async getUnitList() {
    if (Utils.static.units?.length < 1) Utils.static.units = await StorageService.get(StorageConst.LIST_UNIT);
    if (Utils.static.units?.length > 0) return Utils.static.units;
    if (Configs.online) {
      const res = await Fetch.get(ApiConst.UNIT.GET, {}, true);
      Utils.static.units = res?.data || [];
    } else {
      Utils.data.units = await ProductController.getAll();
      Utils.data.units = Utils.data.units.sorted('id', true);
      Utils.data.units = Realms.convertToObjects(Utils.data.units, ProductModel);
      Utils.static.units = Utils.data.units;
    }
    return Utils.static.units || [];
  },

  async onLoginSuccess(data, email, password) {
    try {
      Configs.user = data;
      Utils.applyStaffSession();
      Configs.token = Configs.user.token;
      StorageService.save(StorageConst.TOKEN, Configs.user.token);
      if (Configs.user?.isStaff) {
        if (email) StorageService.save(StorageConst.STAFF_USER_NAME, email);
        if (password) StorageService.save(StorageConst.STAFF_USER_PASSWORD, password);
      } else {
        if (email) StorageService.save(StorageConst.USER_NAME, email);
        if (password) StorageService.save(StorageConst.USER_PASSWORD, password);
      }
      AppAction.updateUserData(Configs.user);
      HomeActionCreator.updateCartList([]);
      File.cleanTmpImages();
      await Funcs.delay(200);

      // Never block post-login navigation if online data bootstrap fails on web.
      try {
        await Utils.initOnlineData();
      } catch (bootstrapError) {
        console.log('initOnlineData error', bootstrapError);
      }

      NavigationService.navigate(ScreenConst.APP_NAVIGATOR, { screen: ScreenConst.HOME_SCREEN });
      TrackingService.init();
      Utils.updateDevice();
      await Utils.updateAccountList({ ...data, password });
    } catch (err) {
      console.log('ERROR', err);
    }
  },

  updateAccountList: async (user) => {
    try {
      if (!user || !user.id) return;
      let accountList = await StorageService.get(StorageConst.ACCOUNT_LIST);
      if (!accountList) accountList = [];
      const find = accountList.find((e) => e.id === user?.id);
      accountList = accountList.filter((e) => e.id !== user?.id);
      const newData = { ...find, ...user };
      const { id, token, email, name, avatar, password } = newData;
      accountList.push({ id, token, email, name, avatar, password });
      Funcs.log('Save accountList', accountList);
      StorageService.save(StorageConst.ACCOUNT_LIST, accountList);
    } catch (err) {
      console.log('ERROR', err);
    }
  },

  async loginWithWithoutEmail() {
    const deviceId = await Utils.getDeviceUUID();
    if (!deviceId) return DropAlert.error('', Lang.account.loginWithoutEmailError);
    Funcs.log('#deviceId', deviceId);

    // Login
    ModalLoading.show();
    const res = await Fetch.post(ApiConst.AUTHENTICATE.LOGIN, { uuid: deviceId, type: 'device' }, { forceFailover: true });
    ModalLoading.hide();
    if (res.status === 200) return Utils.onLoginSuccess(res.data);
    DropAlert.error('', res.data?.code ? Lang.account[res.data.code] : res?.data?.message || Lang.fail);
  },

  async getDeviceUUID() {
    let deviceId = null;
    if (__DEV__ && Configs.mode === 'local') return uuid.v4();
    const keychainStorageType = Keychain?.STORAGE_TYPE || {};
    const fallbackStorage = keychainStorageType.KC || keychainStorageType.AES || keychainStorageType.RSA;
    const option = {
      service: 'DEVICE_UNIQUE',
      storage: AppConst.IS_IOS ? keychainStorageType.KC : keychainStorageType.FB || fallbackStorage
    };
    const hasGetGenericPassword = typeof Keychain?.getGenericPassword === 'function';
    const hasSetGenericPassword = typeof Keychain?.setGenericPassword === 'function';

    if (hasGetGenericPassword) {
      try {
        const credentials = await Keychain.getGenericPassword(option);
        deviceId = credentials?.password;
      } catch (error) {
        Funcs.log('Keychain err 1', error);
      }
    }

    if (!deviceId) {
      deviceId = uuid.v4();
      if (hasSetGenericPassword) {
        try {
          await Keychain.setGenericPassword('deviceId', deviceId, option);
        } catch (error) {
          Funcs.log('Keychain err 2', error);
        }
      }
    }

    return deviceId;
  },

  async logout() {
    await StorageService.remove(StorageConst.TOKEN);
    await StorageService.remove(StorageConst.SHOW_SYNC_OFFLINE);
    await StorageService.remove(StorageConst.CURRENT_WAREHOUSE);
    await StorageService.remove(StorageConst.HAS_LOCAL_DATA);
    Configs.token = null;
    Configs.user = {};
    Configs.staff = null;
    Configs.isManagerApp = true;
    Object.assign(Configs, cloneDeep(defaultSettings));
    await Utils.init();
    HomeActionCreator.updateCartList([]);
    NavigationService.reset(ScreenConst.AUTH_NAVIGATOR, { force: true });
  },

  async updateDevice() {
    if (!Configs.online || Configs.user?.isStaff) return;
    await PushNotificationService.updateDevice();
  }
};

export default Utils;
